export const THUMBCONTAINER_VARIANT_DEFAULT = 'default'
export const THUMBCONTAINER_VARIANT_SMALL = 'small'
